import { render, staticRenderFns } from "./CoefficientForDilapidation.vue?vue&type=template&id=db764862&scoped=true&"
import script from "./CoefficientForDilapidation.vue?vue&type=script&lang=js&"
export * from "./CoefficientForDilapidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db764862",
  null
  
)

export default component.exports